import { render, staticRenderFns } from "./BillWnquiry.vue?vue&type=template&id=5a2f1cd8&scoped=true"
import script from "./BillWnquiry.vue?vue&type=script&lang=js"
export * from "./BillWnquiry.vue?vue&type=script&lang=js"
import style0 from "./BillWnquiry.vue?vue&type=style&index=0&id=5a2f1cd8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f1cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2f1cd8')) {
      api.createRecord('5a2f1cd8', component.options)
    } else {
      api.reload('5a2f1cd8', component.options)
    }
    module.hot.accept("./BillWnquiry.vue?vue&type=template&id=5a2f1cd8&scoped=true", function () {
      api.rerender('5a2f1cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/BillWnquiry.vue"
export default component.exports